import { jsx as a } from "react/jsx-runtime";
import { ah as o } from "../../../vendor-CPVnY93G.js";
import '../../../assets/index36.css';const r = "_separator_18e5c_1", e = {
  separator: r
}, p = () => /* @__PURE__ */ a(o, { className: e.separator, orientation: "horizontal" });
export {
  p as Separator
};
